<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <!-- <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Start Date </label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker v-model="startDate" class="picker" :editable="true" :clearable="false" required />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Date </label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker v-model="endDate" class="picker" :editable="true" :clearable="false" required />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div> -->

                <div class="col-lg-12 col-12">
                  <div class="form-group">
                    <label>Periode Date</label>
                    <DatePicker 
                        v-model:value="periode" 
                        type="date"
                        range
                        format="YYYY-MM-DD"
                        value-type="format"
                        :clearable="true"
                        class="picker"
                        
                        
                    />
                  </div>
                </div>
                <div class="col-lg-12 col-12">
                  <div class="form-group" >
                    <label> employee</label>
                    
                    <div class="" ref="employeeDropdownWrapper">

                      <multi-select :options="employeeList" :selected-options="employees" ref="employeeDropdown" style="z-index:504"
                        placeholder="select Employee" @select="onSelectEmployees">
                      </multi-select>
                    </div>
                    
                  </div>
                </div>

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Generate</button>
                  <!-- <router-link to="departement" class="btn btn-cancel">Cancel</router-link> -->
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>

<style>
.ant-picker-focused {
  border-color: #08b77e !important;
  box-shadow: 0 0 0 2px rgba(24, 255, 74, 0.2);
  border-right-width: 1px !important;
  outline: 0;
}

.ant-picker {
  border-radius: 5px !important;
  height: 40px !important;
}

.ant-picker:hover,
.ant-picker-focused {
  border-color: #08b77e !important;
  border-right-width: 1px !important;
}

.menu.visible {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}

/* .menu.hidden {
  display: block !important;   
  opacity: 1 !important;
  visibility: visible !important;
} */

</style>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";
import { ref, watch } from 'vue';
import { MultiSelect } from 'vue-search-select';

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'

const month = ref({
  month: new Date().getMonth(),
  year: new Date().getFullYear()
});

export default {
  components: {
    DatePicker,
    MultiSelect
  },
  name: "editemployee",
  data() {
    const today = new Date();
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return {
      filter: true,
      title: "Payroll Report (Salary Slip)",
      title1: "generate payroll report (Salary slip)",
      config: "",
      api: "",

      //data
      currentData: {
      },
      employeeList: [],
      employee: "",
      employees: [],
      periode: [],
      lastSelectItemEmployee: {},


      month: month,
      startDate: startDate,
      endDate: endDate,
    };
  },

  async created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'view')


    // Set default date range (1st to last day of current month)
    const storedStart = localStorage.getItem("startCutOff");
    const storedEnd = localStorage.getItem("EndCutOff");

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // zero-based
    
    const startDay = storedStart ? parseInt(storedStart) : 1;
    const endDay = storedEnd ? parseInt(storedEnd) : 0;

    const start = new Date(year, month, startDay);

    let end;
    if (startDay === 1) {
        // If start is 1st → end is last day of same month
        end = new Date(year, month + 1, 0);
    } else {
        if (endDay > 0) {
            // If endDay <= startDay, it should be in the *next* month
            if (endDay <= startDay) {
            end = new Date(year, month + 1, endDay);
            } else {
            end = new Date(year, month, endDay);
            }
        } else {
            // fallback if storedEnd missing
            end = new Date(year, month + 1, 0);
        }
    }
    // const end = new Date(year, month, storedEnd ? parseInt(storedEnd) : 0);

    this.periode = [
      this.formatDateLocal(start),
      this.formatDateLocal(end),
    ];


    await this.index();

  },
  
  mounted() {
      watch(selectedBranch, async () => {
        this.filter = selectedBranch.value;
          await this.index()
      }, { immediate: true })

    document.addEventListener('click', this.handleClickOutside)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },



  methods: {

    formatDateLocal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    onSelectEmployees(items, lastSelectItem) {
      this.employees = items
      this.lastSelectItemEmployee = lastSelectItem

      // reopen dropdown after auto-close
      this.$nextTick(() => { 
        const wrapperRef = this.$refs.employeeDropdownWrapper
        const wrapperEl = wrapperRef?.$el ?? wrapperRef
        if (!wrapperEl) return

        const dropdown = wrapperEl.querySelector('.menu')
        if (dropdown) {
          dropdown.classList.add('visible')
          dropdown.classList.remove('hidden')
          dropdown.style.display = 'block' // extra safeguard
        }
      })
    },

    handleClickOutside(e) {
      const wrapperRef = this.$refs.employeeDropdownWrapper
      const wrapperEl = wrapperRef?.$el ?? wrapperRef
      if (!wrapperEl) return

      if (!wrapperEl.contains(e.target)) {
        const dropdown = wrapperEl.querySelector('.menu')
        if (dropdown) {
          dropdown.classList.remove('visible')
          dropdown.classList.add('hidden')
          dropdown.style.display = 'none'
        }
      }
    },

    async insert() {
      let alertShown = false;

      for (const emp of this.employees) {

        let formData = new FormData();
        appendForm(formData)


        // formData.append('dfrom', this.formatDateLocal(this.startDate));
        // formData.append('dto', this.formatDateLocal(this.endDate));

        if (this.periode && this.periode.length === 2) {
            const [startDate, endDate] = this.periode;
            formData.append("dfrom",  startDate);  // end date
            formData.append("dto", endDate);  // start date
        }


        formData.append('employee_id', emp.value);

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // return;

        const api = base_url + '/v3/reports/report_slip_gaji';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        console.log('ini data overtime:', data)

        if(data.status){
            window.open(data.data.file_report, "_blank");
            
        }else {
            // AlertPopup2("error", "", data.message, true, 1500);
            if (!alertShown) {   
              alertShown = true;
              AlertPopup2("error", "", data.message, true, 1500);
            }
        }

      }
      
      
    },

    async index() {
     
      let formData = new FormData();
      appendForm(formData)

      // if (this.periode && this.periode.length === 2) {
      //     const [startDate, endDate] = this.periode;
      //     formData.append("dfrom",  startDate);  // end date
      //     formData.append("dto", endDate);  // start date
      // }

      for (let [key, value] of formData.entries()) {
          console.log(key, value);
      }
      // return;

        const api = base_url + '/v3/employees/index';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        console.log('ini data overtime:', data)
        
        if(data.status){
            this.data = [];
            const employeeList = data.data.data_employee;

            // this.employeeList = [];

            employeeList.forEach((item, index) => {
                let item_prepare = { value: item.id, text: item.nama  };
                this.employeeList.push(item_prepare);
            });
            
        }else {
            AlertPopup2("error", "", data.message, true, 1500);
        }

      

    },

  },

};
</script>

